
import Pollytts from '../../../utils/Pollytts';

var Polly_settings = {
    awsRegion: "ap-southeast-1",
    pollyVoiceId: "Raveena",
    cacheSpeech: true
}

var TTS = Pollytts(Polly_settings);

const ConvertTextToSpeech = ({
    correctAnswer,
    elementClass,
    questionId,
    score,
}) => {  
        if (score === 0 || score < 0.5) {
            TTS.getAudioUrl(correctAnswer, Polly_settings.pollyVoiceId, `${elementClass}${questionId}`);
        }    
}



export default ConvertTextToSpeech;